export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "sales_target": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("target")), " ventes → ", _interpolate(_named("reward"))])},
        "points_per_euro": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["1 € = ", _interpolate(_named("points")), " points"])}
      },
      "en": {
        "sales_target": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("target")), " sales → ", _interpolate(_named("reward"))])},
        "points_per_euro": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["€1 = ", _interpolate(_named("points")), " points"])}
      }
    }
  })
}
